export const Statuses: Record<string, string> = {
  SOLVED: "Решено",
  NOT_SOLVED: "Не решено",
};
